import './App.css';
import './style.css';
import React, { useEffect } from 'react';
import initializePackery from './dragdrop';
import {  handleButtonClick, handleCloseClick, handleMemoClick, handleDicisionClick, submitForm } from './uiEventHandler';
import Sprintboard from "./hooks/sprintboard";
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Top from './Top';
import Signin from './Signin';

function App() {

  return (
	
	<BrowserRouter>
		<Routes>
			<Route path={'/'} element={<Signin/>}></Route>
			<Route path={'/Top'} element={<Top/>}></Route>
		</Routes>
	</BrowserRouter>
  );
}

export default App;
